import { create } from 'zustand'

interface BridgeFormData {
  amount: string
  bscAddress: string
  useSameAddress: boolean
}

type BridgeStep = 'input' | 'approve' | 'lock' | 'pending' | 'success' | 'error'

interface BridgeState {
  formData: BridgeFormData
  setFormData: (data: Partial<BridgeFormData>) => void
  resetForm: () => void

  currentStep: BridgeStep
  setCurrentStep: (step: BridgeStep) => void

  pendingTxHash: string | null
  setPendingTxHash: (hash: string | null) => void

  lockId: bigint | null
  setLockId: (id: bigint | null) => void

  error: string | null
  setError: (error: string | null) => void

  reset: () => void
}

const initialFormData: BridgeFormData = {
  amount: '',
  bscAddress: '',
  useSameAddress: true,
}

export const useBridgeStore = create<BridgeState>((set) => ({
  formData: initialFormData,
  setFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data },
    })),
  resetForm: () => set({ formData: initialFormData }),

  currentStep: 'input',
  setCurrentStep: (step) => set({ currentStep: step }),

  pendingTxHash: null,
  setPendingTxHash: (hash) => set({ pendingTxHash: hash }),

  lockId: null,
  setLockId: (id) => set({ lockId: id }),

  error: null,
  setError: (error) => set({ error }),

  reset: () =>
    set({
      formData: initialFormData,
      currentStep: 'input',
      pendingTxHash: null,
      lockId: null,
      error: null,
    }),
}))
